import {createAction} from 'typesafe-actions';

import type * as Types from './types';

export const setSemanticLegendSettings = createAction(
  '@view/semanticLegend/setSemanticLegendSettings',
  action => (ref: Types.Ref, semanticLegendSettings: Types.SemanticLegend) =>
    action({ref, semanticLegendSettings})
);
